export const formatDate = (date) => {
	if (!date) return "";

	if (date instanceof Date) {
		if (isNaN(date.getTime())) return "";
		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	}

	const dateString = String(date);
	const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);

	if (match) {
		const [, year, month, day] = match;
		return `${day}-${month}-${year}`;
	}

	const dateObj = new Date(dateString);
	if (isNaN(dateObj.getTime())) return "";

	const day = String(dateObj.getDate()).padStart(2, "0");
	const month = String(dateObj.getMonth() + 1).padStart(2, "0");
	const year = dateObj.getFullYear();

	return `${day}-${month}-${year}`;
};

export const formatDateTime = (datetime) => {
	if (!datetime) return "";

	const dateString = String(datetime);
	const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);

	if (match) {
		const [, year, month, day, hours, minutes] = match;
		return `${day}-${month}-${year} ${hours}:${minutes}`;
	}

	const dateObj = new Date(dateString);
	if (isNaN(dateObj.getTime())) return formatDate(datetime);

	const day = String(dateObj.getDate()).padStart(2, "0");
	const month = String(dateObj.getMonth() + 1).padStart(2, "0");
	const year = dateObj.getFullYear();
	const hours = String(dateObj.getHours()).padStart(2, "0");
	const minutes = String(dateObj.getMinutes()).padStart(2, "0");

	return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const parseDateFromBackendValue = (value, endOfDay = false) => {
	if (!value) return null;

	if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
		const [year, month, day] = value.split("-").map(Number);
		if (endOfDay) {
			return new Date(year, month - 1, day, 23, 59, 59, 999);
		}
		return new Date(year, month - 1, day, 0, 0, 0, 0);
	}

	const parsedDate = new Date(value);
	if (Number.isNaN(parsedDate.getTime())) return null;
	return parsedDate;
};
